module.exports = __webpack_public_path__ + "static/chal_fct3-70da92afb516d2d6904b60ef728590a1.jpg";